<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="icon">
    <g>
      <path
        style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans"
        d="M 25 3 C 12.86158 3 3 12.86158 3 25 C 3 37.13842 12.86158 47 25 47 C 37.13842 47 47 37.13842 47 25 C 47 12.86158 37.13842 3 25 3 z M 25 5 C 36.05754 5 45 13.94246 45 25 C 45 36.05754 36.05754 45 25 45 C 13.94246 45 5 36.05754 5 25 C 5 13.94246 13.94246 5 25 5 z M 24 14 L 24 24 L 14 24 L 14 26 L 24 26 L 24 36 L 26 36 L 26 26 L 36 26 L 36 24 L 26 24 L 26 14 L 24 14 z"
        overflow="visible"
        enable-background="accumulate"
        font-family="Bitstream Vera Sans"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "add-item-outline",
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
